var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container",style:({
          width: this.skin.sideBarWidth,
          height: this.skin.topNavHeight,
          'line-height': this.skin.topNavHeight,
          'background-color': this.$store.getters.theme})},[(!_vm.$store.getters.topNav && _vm.sidebar.collapsed)?_c('h2',{staticClass:"content"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo}})]):_c('h2',{staticClass:"content"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo}}),_c('span',{staticClass:"ml10"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }